import * as React from 'react';
import Alert from '@mui/material/Alert';
import { useCookies } from 'react-cookie';
import CampaignIcon from '@mui/icons-material/Campaign';
import { isCurrentTimeInPeriod } from '../../utils';

export type SystemNotificationProps = {
  content: string | undefined;
  period: {
    start?: Date;
    end?: Date;
  };
};

const cookieMaxAge = 24 * 60 * 60; // 24 hours

export const SystemNotification: React.FunctionComponent<
  SystemNotificationProps
> = props => {
  const { content, period } = props;
  const [cookies, setCookie] = useCookies(['systemNotificationClose']);
  const systemNotificationClose = cookies.systemNotificationClose;
  const handleCloseNotification = (): void => {
    setCookie('systemNotificationClose', true, { maxAge: cookieMaxAge });
  };
  const { start, end } = period;
  const inPeriod = isCurrentTimeInPeriod(start, end);
  const shouldDisplay = content && inPeriod && !systemNotificationClose;

  return shouldDisplay ? (
    <Alert
      severity="warning"
      className="w-full"
      sx={{
        paddingY: '0.5em',
        paddingLeft: '3em',
        borderRadius: 0,
      }}
      iconMapping={{
        warning: <CampaignIcon fontSize="inherit" />,
      }}
      onClose={handleCloseNotification}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Alert>
  ) : (
    false
  );
};
